/* eslint-disable no-unused-vars */

import { Button, Grid, TextField } from '@material-ui/core';
import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { useEmailer } from 'src/hooks/email/useEmailer';

interface Props {}

const EmailerToolbar: FC<Props> = () => {
  const { filters, isLoading, getEmailerList, setFilters } = useEmailer();
  const [keyword, setKeyword] = useState<string | null>(null);

  const applyFilter = useCallback(() => {
    if (isLoading) {
      return;
    }
    setFilters({ title: keyword ?? null, page: 1 });
  }, [isLoading, keyword, setFilters]);

  useEffect(() => {
    if (filters) {
      getEmailerList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <TextField
          label="Search Emailer"
          fullWidth
          variant="outlined"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => (e.key === 'Enter' ? applyFilter() : null)}
        />
      </Grid>
      <Grid item xs>
        <Button
          disabled={isLoading}
          variant="contained"
          color="primary"
          style={{ height: '100%' }}
          onClick={applyFilter}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

export default memo(EmailerToolbar);
